<template>
  <v-card>
    <div v-if="global_layers.globalLayers.length > 0">
      {{ $t('NavigationSideBar.global') }}
      <v-divider
        class="my-3"
        color="white"
      />
      <v-checkbox
        v-for="globalLayer in global_layers.globalLayers"
        :key="globalLayer.global_layer_id"
        v-model="global_layers.selectedGlobalLayer"
        class="py-2 pr-1 d-flex align-center checkbox_row"
        inset
        dense
        color="green"
        dark
        multiple
        hide-details
        :value="globalLayer"
        @click.native="setGlobalLayer([globalLayer, 'GLOBAL LAYER'])"
      >
        <template v-slot:label>
          <span style="font-size:12px">{{ $t(`GlobalLayer.${globalLayer.global_layer_id}.title`) }}</span>
        </template>
        <template v-slot:append>
          <span
            class="circle_layer ma-1"
            :style="{ backgroundColor: globalLayer.color }"
          />
        </template>
      </v-checkbox>
    </div>
    <div
      v-if="global_layers.customerLayers.length > 0"
      class="mt-6"
    >
      {{ $t('NavigationSideBar.layer') }}
      <v-divider
        class="my-3"
        color="white"
      />
      <v-checkbox
        v-for="customerLayer in global_layers.customerLayers"
        :key="customerLayer.global_layer_id"
        v-model="global_layers.selectedGlobalLayer"
        class="py-2 pr-1 d-flex align-center checkbox_row"
        inset
        dense
        color="green"
        dark
        multiple
        hide-details
        :value="customerLayer"
        @click="setGlobalLayer([customerLayer, 'CUSTOMER LAYER'])"
      >
        <template v-slot:label>
          <span style="font-size:12px">{{ $t(`CustomerLayer.${customerLayer.global_layer_id}.title`) }}</span>
        </template>
        <template v-slot:append>
          <span
            class="circle_layer ma-1"
            :style="{ backgroundColor: customerLayer.color }"
          />
        </template>
      </v-checkbox>
    </div>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';


export default {
  components: {
  },
  props: {
  },
  data () {
    return {};
  },
  computed: {
    ...mapState(['app_user', 'global_layers'])
  },
  watch: {
    $route() {}
  },
  mounted() {
    this.defaultServiceWS();
  },
  methods: {
    ...mapActions(['setGlobalLayer']),
    defaultServiceWS() {
      if (this.app_user.defaultService.GLOBAL?.service_type === 'WS' && this.global_layers.selectedGlobalLayer.length > 0) {
        this.app_user.defaultService.GLOBAL.global_layer_id.forEach(item => {
          const gLayer = this.global_layers.globalLayers.find(layer => layer.global_layer_id === item.id);
          this.global_layers.selectedGlobalLayer.push(gLayer);
        });

        this.app_user.defaultService.GLOBAL.customer_layer_id.forEach(item => {
          const cLayer = this.global_layers.customerLayers.find(layer => layer.global_layer_id === item.id);
          this.global_layers.selectedGlobalLayer.push(cLayer);
        });
      }
    }
  }
};
</script>

<style scoped>
.checkbox_row {
  transition: background-color .12s ease, transform .12s ease;
  cursor: pointer;
}
.checkbox_row:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.circle_layer {
  border: 1px solid white;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
  transition: transform .12s ease, box-shadow .12s ease;
  vertical-align: middle;
}
.checkbox_row:hover .circle_layer {
  transform: scale(1.15);
}
</style>

